/* 🤖 this file was generated by svg-to-ts */
export const iconOwnbitwallet: {
  name: 'ownbitwallet';
  data: string;
} = {
  name: 'ownbitwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m.08 29.03C8.91 29.09 2.97 23.19 2.97 16c0-4.04 1.87-7.85 5.06-10.31.41-.32.97-.38 1.44-.15s.77.71.77 1.23v9.24c0 2.32 1.4 4.42 3.54 5.31s4.61.4 6.25-1.25a5.74 5.74 0 0 0 1.24-6.26 5.74 5.74 0 0 0-5.97-3.51.856.856 0 0 1-.96-.85V3.86c0-.45.34-.82.79-.86.27-.02.55-.03.83-.03 7.18-.03 13.03 5.78 13.06 12.98s-5.77 13.06-12.95 13.09z"/></svg>`,
};
